'use strict';

function forceUpdateBodyOverflow() {
  if (!window.safari) {
    return;
  }

  // If you move cursor over sidebar while it's still animating
  // and try to scroll, it will get stuck in desktop Safari.

  // Temporarily setting it to 'scroll' and back
  // seems to fix the problem, at least in Safari 8.

  var prevOverflow = document.body.style.overflow;
  document.body.style.overflow = 'scroll';

  setTimeout(() => {
    if (document.body.style.overflow === 'scroll') {
      document.body.style.overflow = prevOverflow;
    }
  });
}

module.exports = forceUpdateBodyOverflow;


/** WEBPACK FOOTER **
 ** ./utils/forceUpdateBodyOverflow.js
 **/